import { queryOptions } from "@tanstack/react-query";
import axios from "axios";
import { backendURL } from "../url";

export type PaymentTransaction = {
  chargeId: string;
  amount: number;
  amountRefunded: number;
  currency: string;
  refunded: boolean;
  paymentMethod: string;
  country: string;
  brand: string;
  last4: string;
  email: string;
  phoneNumber?: number;
  name?: string;
  receipt: string;
};

export type PaymentsPage = {
  transactions: PaymentTransaction[];
  hasMore: boolean;
  nextCursor: string | null;
};

export const managePaymentQueryOptions = () => {
  return queryOptions({
    queryKey: ["payments"],
    queryFn: () => getPayments(),
  });
};

export const getPayments = async (startingAfter?: string): Promise<PaymentsPage> => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${backendURL}/api/booking/all-transactions`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: startingAfter ? { starting_after: startingAfter } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error("Error getting payments", error);
    throw error;
  }
};
